module.exports = __webpack_public_path__ + "static/apple-touch-icon-b6edd83a323ab4d794746ae5cf1ca6ec.png";